import { useMemo } from 'react';

import { useAuth } from '@/store/auth/auth.store';

import type { Permission } from './permissions.catalog';

const EMPTY: ReadonlySet<string> = new Set();

export const usePermissions = () => {
  const rights = useAuth((s) => s.session?.rights);
  return useMemo(() => {
    const set = rights ?? EMPTY;
    return {
      can: (p: Permission) => set.has(p),
      canAny: (ps: Permission[]) => ps.some((p) => set.has(p)),
      canAll: (ps: Permission[]) => ps.every((p) => set.has(p)),
      rights: set,
    };
  }, [rights]);
};
